module.exports = __webpack_public_path__ + "static/media/House_Beer_client_page3.0b3be20f.png";